import React from 'react'

const SideInfoIcon = (
  <>
    <path
      d="M15.0835 19.5837H0.91683C0.456413 19.5837 0.0834961 19.2107 0.0834961 18.7503V1.25033C0.0834961 0.789909 0.456413 0.416992 0.91683 0.416992H10.9168L15.9168 5.41699V18.7503C15.9168 19.2107 15.5439 19.5837 15.0835 19.5837Z"
      fill="#2EB9FF"
    />
    <path
      d="M10.917 0.416992V4.58366C10.917 5.04408 11.2899 5.41699 11.7503 5.41699H15.917L10.917 0.416992Z"
      fill="#1890FF"
    />
    <path
      d="M8.00033 15.4167C7.77033 15.4167 7.58366 15.23 7.58366 15V9.58333H6.33366C6.10366 9.58333 5.91699 9.39667 5.91699 9.16667C5.91699 8.93667 6.10366 8.75 6.33366 8.75H8.00033C8.23033 8.75 8.41699 8.93667 8.41699 9.16667V15C8.41699 15.23 8.23033 15.4167 8.00033 15.4167Z"
      fill="white"
    />
    <path
      d="M9.66699 15.4173H6.33366C6.10366 15.4173 5.91699 15.2307 5.91699 15.0007C5.91699 14.7707 6.10366 14.584 6.33366 14.584H9.66699C9.89699 14.584 10.0837 14.7707 10.0837 15.0007C10.0837 15.2307 9.89699 15.4173 9.66699 15.4173Z"
      fill="white"
    />
    <path
      d="M8.00033 7.50065C8.46056 7.50065 8.83366 7.12756 8.83366 6.66732C8.83366 6.20708 8.46056 5.83398 8.00033 5.83398C7.54009 5.83398 7.16699 6.20708 7.16699 6.66732C7.16699 7.12756 7.54009 7.50065 8.00033 7.50065Z"
      fill="white"
    />
  </>
)

export default SideInfoIcon
